import { useEffect, useState } from "react";
import { getCases } from "../../utilities/cases-service";
import Loader from "../../components/Loader/Loader";
import CaseCard from "./CaseCard";
import "./IndexPage.css"

import { listAllUsers } from "../../utilities/users-service";



export default function IndexPage ({user}) {


    function clearAllCache() {
        console.log("Clearing all cache");
        localStorage.clear();
    }

    // clearAllCache()
    // clearing all cache may help with localStorage issues
    // this is useful here 10.1.25 because it allows you to ensure all cleared when you return to the question a second time

    // IMPORTANT: you have to toggle OFF clearAllCache here when trying to build new cases as an Admin... otherwise you get a post error, probably bc it signs you out by clearing the cahce


        // trying this to show users - adding 10.21.25 - toggle on and off to get users list

        // useEffect(() => {
        //     (async () => {
        //     try {
        //         const users = await listAllUsers();
        //         console.log("All users:", users);
        //     } catch (err) {
        //         console.error("Error fetching users:", err);
        //     }
        //     })();
        // }, []);

        

    
    const [cases, setCases] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    async function handleRequest() {
        const response = await getCases()
        if (typeof response === "object") {
            setCases(response)
            setIsLoading(false)
            // console.log(response)
            // toggle this to save all cases!
            // console.log(user)
        } else {
            console.log("error: ", response)
        }
    }



    useEffect(() => {
        handleRequest();
    }, [])

    const casesList = cases?.map((c, idx) => <CaseCard caseStudy={c} idx={idx} key={idx} handleRequest={handleRequest} user={user}/>)

    return isLoading ? (
        <Loader />
    ) : (


         

        <section className="index-page-ctr">
               
               { user ? 
                        <>

                        <div className="index-grid">
                            {casesList}
                        </div>
                        
                           
                        </>
                        :

                        <h4>Please log in to view prior cases.</h4>

                 
                    }
              
                 </section>
    );

}
